import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { StaffingRequestView } from "@/schemas/staffing-requests";
import { formatDate, summarizeRequest } from "./request-copy";
import { StaffingStatusBadge } from "./StaffingStatusBadge";

interface Props {
  request: StaffingRequestView;
  onOpen: (id: string) => void;
}

export function RequestQueueRow({ request, onOpen }: Props) {
  const proposed = request.fulfilledResource ?? request.suggestedResource;
  return (
    <tr
      onClick={() => onOpen(request.id)}
      className="cursor-pointer border-t border-border hover:bg-muted/40"
    >
      <td className="px-3 py-2.5">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onOpen(request.id);
          }}
          className="text-left font-medium text-foreground hover:underline"
        >
          {summarizeRequest(request)}
        </button>
        <div className="max-w-xs truncate text-xs text-muted-foreground" title={request.reason}>
          {request.reason}
        </div>
      </td>

      <td className="px-3 py-2.5">
        <div className="text-foreground">{request.solution.name}</div>
        <div className="text-xs text-muted-foreground">{request.account?.name ?? "—"}</div>
      </td>

      <td className="px-3 py-2.5">
        {request.kind === "Remove" ? (
          <span className="text-xs text-muted-foreground">—</span>
        ) : proposed ? (
          <span className="inline-flex items-center gap-1 text-foreground">
            {request.fulfilledResource &&
            request.suggestedResource &&
            request.fulfilledResource.id !== request.suggestedResource.id ? (
              <>
                <span className="text-muted-foreground line-through">
                  {request.suggestedResource.name}
                </span>
                <ArrowRight className="h-3 w-3 text-muted-foreground" />
              </>
            ) : null}
            {proposed.name}
          </span>
        ) : (
          <span className="text-xs text-muted-foreground">RM to choose</span>
        )}
      </td>

      <td className="px-3 py-2.5">
        {request.priority ? (
          <Badge variant="secondary" className="font-medium">
            {request.priority.name}
          </Badge>
        ) : (
          <span className="text-xs text-muted-foreground">—</span>
        )}
      </td>

      <td className="px-3 py-2.5">
        <StaffingStatusBadge status={request.status} />
      </td>

      <td className="px-3 py-2.5 text-sm text-muted-foreground">
        <div>{request.requestedBy?.name ?? "—"}</div>
        <div className="text-xs">{formatDate(request.createdAt)}</div>
      </td>
    </tr>
  );
}
